<script>
    import { createEventDispatcher } from 'svelte';
    const dispatch = createEventDispatcher();
    // export let gameId;
    import { teamData } from '../multi/teamData';
    export let game;
    export let mode = '';
    export let lang;
    // export let lang = 'pl';
    import { trainerTexts as texts } from './Panel/trainerTexts';
    import { teamColours } from '../Player/texts';
    import CopytoClip from './Panel/CopytoClip.svelte';
    let buttons = {
        pomaranczowi: '',
        zieloni: '',
        fioletowi: '',
        niebiescy: '',
    };
    let players = [];
    aggregatePlayers();

    function aggregatePlayers() {
        // console.log(teamData);
        for (let prop in teamData) {
            players.push(teamData[prop]);
        }
    }
    function copy(content) {
        const app = new CopytoClip({
            target: document.getElementById('clipboard'),
            props: { content },
        });
        app.$destroy();
    }

    const urlBase = {
        // stage: 'http://localhost:8080',
        stage: 'https://czarnainez-stage.mindlab.pl/',
        production: 'https://czarnainez.mindlab.pl/',
        development: 'http://localhost:8080',
    };
</script>

<div
    class="game"
    class:single-game={!game.isGameOn && !game.isGameEnd}
    class:running={game.isGameOn}
    class:closed={game.isGameEnd}
>
    <div class="section-bar">
        <div class="section-text">
            {texts[lang].game}: {game.code}, {texts[lang].lang}: {game.lang}
        </div>
        <hr />
    </div>
    <p class="p__game">
        {texts[lang].game_status}
        {#if game.isGameOn && !game.isGameEnd}
            {texts[lang].game_active}
        {:else if game.isGameEnd}
            {texts[lang].game_end}
        {:else}
            {texts[lang].game_inactive}
        {/if}
    </p>

    <div class="dropdown">
        <input
            type="checkbox"
            class="drop-switch"
            id="drop-council{game.code}"
        />
        <label for="drop-council{game.code}" class="btn__reverse drop-label">
            <span class="btn-text__main">{texts[lang].links_set}</span>
            <div class="icon" />
        </label>
        <ul class="submenu">
            <li>
                <!-- <p> -->
                <!-- &#183;<span class="log-trainer"> -->
                {texts[lang].trainer}
                <!-- </span> -->
                <!-- </p> -->
                <button
                    class="btn btn__smaller"
                    on:click={() =>
                        copy(
                            urlBase[mode] +
                                '?game=' +
                                game.code +
                                '&team=trener'
                        )}>{texts[lang].copy}</button
                >
            </li>
            {#each players as player}
                <li>
                    <!-- <p>
                    &#183; -->
                    <span class="log-{player.class}">
                        {teamColours[lang][player.colour]}
                    </span>

                    <button
                        class="btn btn__smaller btn__{player.class}"
                        on:click={() =>
                            copy(
                                urlBase[mode] +
                                    '?game=' +
                                    game.code +
                                    '&team=' +
                                    player.code
                            )}>{texts[lang].copy}</button
                    >
                    <!-- </p> -->
                </li>
            {/each}
        </ul>
    </div>
    <button
        class="btn btn__smaller"
        class:btn--inactive={game.isGameOn || game.isGameEnd}
        disabled={game.isGameOn || game.isGameEnd}
        on:click={() =>
            dispatch('deleteGame', {
                gameId: game.gameId,
                gameCode: game.code,
            })}
        >{texts[lang].delete_game}
    </button>

    <hr class="u-flex-break" />
</div>
